const DELAYS = ['0s', '0.18s', '0.36s'];

export function TypingIndicator() {
  return (
    <div className="flex items-end gap-2 px-4 py-1">
      {/* Aria avatar */}
      <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#1b312e] text-xs font-semibold text-white">
        A
      </div>

      <div className="flex items-center gap-1.5 rounded-2xl rounded-bl-sm bg-[#DDECEB] px-4 py-3">
        {DELAYS.map((delay, i) => (
          <span
            key={i}
            className="aria-dot h-2 w-2 rounded-full bg-[#53978e]"
            style={{ animationDelay: delay }}
          />
        ))}
      </div>
    </div>
  );
}
